import MetricDetailTableHeaders from './MetricDetailTableHeaders';

export default MetricDetailTableHeaders;
